export default __webpack_public_path__ + "static/media/olivine54.f3c6747b.png";